import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import GuestChatWidget from './GuestChatWidget';
import './landing.scss';
import SeoHead from '../../../Components/Common/SeoHead';

const GDPRPolicy: React.FC = () => {
  return (
    <div className="layout-wrapper landing">
      <SeoHead
        title="GDPR Compliance — CodeRom"
        description="CodeRom GDPR compliance & your data rights under UK/EU law."
      />
      <Navbar />

      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '120px 20px 60px'
      }}>
        {/* Breadcrumb */}
        <div style={{ marginBottom: '24px', fontSize: '14px' }}>
          <Link to="/" style={{ color: '#6366f1', textDecoration: 'none' }}>Home</Link>
          <span style={{ margin: '0 8px', color: '#9ca3af' }}>›</span>
          <span style={{ color: '#6b7280' }}>GDPR Compliance</span>
        </div>

        {/* Başlık kartı */}
        <div style={{
          background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
          borderRadius: '16px',
          padding: '40px',
          marginBottom: '32px',
          color: 'white'
        }}>
          <h1 style={{ fontSize: '32px', fontWeight: 700, margin: '0 0 8px' }}>GDPR Compliance</h1>
          <p style={{ fontSize: '14px', opacity: 0.8, margin: 0 }}>Last updated: April 2026 · Enerfix Limited</p>
        </div>

        {/* Ana içerik kartı */}
        <div style={{
          background: '#ffffff',
          borderRadius: '16px',
          border: '1px solid #e5e7eb',
          padding: '40px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>

          {/* Section 1 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: 0,
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              1. Our commitment
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              Enerfix Limited, trading as Coderom, is committed to complying with the <strong>UK General Data
              Protection Regulation (UK GDPR)</strong> and the <strong>Data Protection Act 2018</strong>. We take
              the protection of your personal data seriously.
            </p>
          </div>

          {/* Section 2 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              2. Data controller
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              Enerfix Limited is the data controller for all personal data processed through the Coderom platform.
            </p>
            <div style={{
              background: '#eff6ff',
              borderLeft: '4px solid #3b82f6',
              borderRadius: '0 12px 12px 0',
              padding: '16px 20px',
              margin: '20px 0'
            }}>
              <p style={{ color: '#1e40af', fontSize: '14px', margin: 0 }}>
                <strong>Contact:</strong> <a href="mailto:support@coderom.com" style={{ color: '#1e40af', textDecoration: 'underline' }}>support@coderom.com</a>
              </p>
            </div>
          </div>

          {/* Section 3 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              3. Your rights under GDPR
            </h2>

            <div style={{
              overflowX: 'auto',
              margin: '20px 0',
              borderRadius: '12px',
              border: '1px solid #e5e7eb'
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '14px'
              }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb',
                      width: '30%'
                    }}>Right</th>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb',
                      width: '40%'
                    }}>Description</th>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb',
                      width: '30%'
                    }}>How to exercise</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontWeight: 600 }}>Right of access</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Request a copy of your personal data</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Email support@coderom.com</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontWeight: 600 }}>Right to rectification</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Correct inaccurate personal data</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Update in Settings or email us</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontWeight: 600 }}>Right to erasure</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Request deletion of your data</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Email support@coderom.com</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontWeight: 600 }}>Right to restrict processing</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Limit how we use your data</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Email support@coderom.com</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontWeight: 600 }}>Right to data portability</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Receive your data in a portable format</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Email support@coderom.com</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151', fontWeight: 600 }}>Right to object</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Object to processing based on legitimate interest</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Email support@coderom.com</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '12px 16px', color: '#374151', fontWeight: 600 }}>Right to withdraw consent</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Withdraw consent at any time</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Email support@coderom.com or update Settings</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div style={{
              background: '#eff6ff',
              borderLeft: '4px solid #3b82f6',
              borderRadius: '0 12px 12px 0',
              padding: '16px 20px',
              margin: '20px 0'
            }}>
              <p style={{ color: '#1e40af', fontSize: '14px', margin: 0 }}>
                We will respond to all requests within <strong>30 days</strong>, as required by law.
              </p>
            </div>
          </div>

          {/* Section 4 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              4. Data Protection Officer
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              For a company of our size, a formal DPO is not required under UK GDPR. However, all data protection
              enquiries can be directed to: <a href="mailto:support@coderom.com" style={{ color: '#6366f1', textDecoration: 'none', fontWeight: 500 }}>support@coderom.com</a>
            </p>
          </div>

          {/* Section 5 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              5. Data processing activities
            </h2>

            <div style={{
              overflowX: 'auto',
              margin: '20px 0',
              borderRadius: '12px',
              border: '1px solid #e5e7eb'
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '14px'
              }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Activity</th>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Legal basis</th>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Data involved</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Account management</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Contract</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Email, name, password</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Subscription billing</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Contract</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Payment details, billing address</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>eBay integration</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Contract + Consent</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>eBay account data, listings</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Price monitoring</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Contract</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Amazon product data</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Daily reports</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Consent</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Usage data, sales data</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Platform improvement</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Legitimate interest</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Usage analytics</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Customer support</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Contract</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Communication records</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Section 6 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              6. International data transfers
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              Your data is primarily processed within the UK and EEA. Where data is transferred outside these areas
              (e.g., to US-based service providers), we ensure appropriate safeguards are in place, such as
              <strong> Standard Contractual Clauses</strong>.
            </p>
          </div>

          {/* Section 7 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              7. Data breach notification
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              In the event of a data breach that poses a risk to your rights and freedoms, we will:
            </p>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'Notify the Information Commissioner\'s Office (ICO) within 72 hours',
                'Notify affected individuals without undue delay',
                'Document the breach and our response'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 8 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              8. Complaints
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              If you are not satisfied with how we handle your data, you have the right to lodge a complaint with
              the <strong>Information Commissioner's Office (ICO)</strong>:
            </p>
            <div style={{
              background: '#f8fafc',
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              padding: '20px',
              margin: '20px 0'
            }}>
              <p style={{ fontSize: '14px', color: '#374151', margin: '0 0 8px', fontWeight: 600 }}>Information Commissioner's Office</p>
              <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 4px' }}>
                Website: <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer" style={{ color: '#6366f1', textDecoration: 'none', fontWeight: 500 }}>ico.org.uk</a>
              </p>
              <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
                Phone: 0303 123 1113
              </p>
            </div>
          </div>

          {/* Contact bölümü */}
          <div style={{
            background: '#f8fafc',
            borderRadius: '12px',
            padding: '24px',
            marginTop: '40px',
            textAlign: 'center'
          }}>
            <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1e1b4b', margin: '0 0 8px' }}>
              Questions about GDPR compliance?
            </h3>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 16px' }}>
              Contact our team at <a href="mailto:support@coderom.com" style={{ color: '#6366f1' }}>support@coderom.com</a>
            </p>
            <Link to="/" style={{
              display: 'inline-block',
              padding: '10px 24px',
              background: '#6366f1',
              color: 'white',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500
            }}>
              ← Back to Home
            </Link>
          </div>

        </div>
      </div>

      <Footer />
      <GuestChatWidget />
    </div>
  );
};

export default GDPRPolicy;
